import KeyFlowVO from './KeyFlowVO';

type ConfigVOProps = {
  FORCED_HIDE_TEAM: number[];
  FORCED_SHOW_TEAM: number[];
};

class ConfigVO extends KeyFlowVO {
  forcedHideTeam: number[];
  forcedShowTeam: number[];

  constructor(data: ConfigVOProps) {
    super(data);
    this.forcedHideTeam = data.FORCED_HIDE_TEAM;
    this.forcedShowTeam = data.FORCED_SHOW_TEAM;
  }
}

export default ConfigVO;
